import styled from 'styled-components';

import {fonts} from '../../styles/global';

export const Title = styled.div<{
  labelColor: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 61px;

  h1 {
    padding: 0 20px;
    font-family: ${fonts.justSansBold};
    font-size: 36px;
    text-align: center;
    color: ${props => props.labelColor};

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }
`;

export const TitleDivider = styled.div<{
  dividerColor: string;
}>`
  width: 61px;
  height: 6px;
  background-color: ${props => props.dividerColor};
`;
